<template>
  <b-modal
    id="modal-scrollable"
    v-model="$store.state.someVariables.showModifyTable"
    no-close-on-backdrop
    title="Bonificación"
    @hidden="resetModal"
  >
    <b-row class="mt-2">
      <!-- <b-col md="1" style="padding: 4px;">
        <div class="form-label-group">
          <b-form-input id="floating-pts" placeholder="Pts" type="number" />
          <label for="floating-pts">Pts</label>
        </div>
      </b-col>
      <b-col md="1" style="padding: 4px;">
        <div class="form-label-group">
          <b-form-input id="floating-pts" placeholder="PJ" type="number" />
          <label for="floating-pts">PJ</label>
        </div>
      </b-col>
      <b-col md="1" style="padding: 4px;">
        <div class="form-label-group">
          <b-form-input id="floating-pts" placeholder="PG" type="number" />
          <label for="floating-pts">PG</label>
        </div>
      </b-col>
      <b-col md="1" style="padding: 4px;">
        <div class="form-label-group">
          <b-form-input id="floating-pts" placeholder="PP" type="number" />
          <label for="floating-pts">PP</label>
        </div>
      </b-col>
      <b-col md="1" style="padding: 4px;">
        <div class="form-label-group">
          <b-form-input id="floating-pts" placeholder="PE" type="number" />
          <label for="floating-pts">PE</label>
        </div>
      </b-col>
      <b-col md="1" style="padding: 4px;">
        <div class="form-label-group">
          <b-form-input id="floating-pts" placeholder="PNP" type="number" />
          <label for="floating-pts">PNP</label>
        </div>
      </b-col>
      <b-col md="1" style="padding: 4px;">
        <div class="form-label-group">
          <b-form-input id="floating-pts" placeholder="GF" type="number" />
          <label for="floating-pts">GF</label>
        </div>
      </b-col>
      <b-col md="1" style="padding: 4px;">
        <div class="form-label-group">
          <b-form-input id="floating-pts" placeholder="GC" type="number" />
          <label for="floating-pts">GC</label>
        </div>
      </b-col>
      <b-col md="1" style="padding: 4px;">
        <div class="form-label-group">
          <b-form-input id="floating-pts" placeholder="B" type="number" />
          <label for="floating-pts">B</label>
        </div>
      </b-col> -->
      <b-col md="4" style="padding: 4px;">
        <div class="form-label-group">
          <b-form-input
            id="floating-pts"
            placeholder="Bonificacion"
            type="number"
            v-model="bonificacion"
          />
          <label for="floating-pts">Bonificacion</label>
        </div>
      </b-col>
      <b-col md="8" style="padding: 4px;">
        <div class="form-label-group">
          <b-form-textarea
            id="textarea-auto-height"
            placeholder="Motivo"
            rows="2"
            size="sm"
            max-rows="3"
            v-model="motivo"
          />
          <label for="floating-auto-height">Motivo</label>
        </div>
      </b-col>
    </b-row>
    <b-row
      class="mt-0 p-0 border"
      style="background-color:#adadad; color:white; font-size:12px"
    >
      <b-col md="3" class="d-flex justify-content-center">Fecha</b-col>
      <b-col md="6">
        Motivo
      </b-col>
      <b-col md="2">
        Bonificacion
      </b-col>
      <b-col md="1"> </b-col>
    </b-row>
    <b-row
      v-for="item in listBonificaciones"
      :key="item.id"
      class="mt-0 p-0 border"
      style="font-size:12px"
    >
      <b-col md="3">
        {{ item.fecha }}
      </b-col>
      <b-col md="6">
        <span>{{ item.motivo }} </span>
      </b-col>
      <b-col md="2" class="d-flex justify-content-center align-items-center">
        {{ item.puntos }}
      </b-col>

      <b-col md="1" class="d-flex p-0">
        <b-button
          v-if="
            USER().rol === ROLES.SUPER ||
              USER().rol === ROLES.ADMIN ||
              USER().rol === ROLES.SANCIONES ||
              USER().rol === ROLES.TECNICA
          "
          @click="deleteSancionEquipo(item)"
          variant="flat-danger"
          class="btn-icon"
          size="sm"
        >
          <feather-icon size="14" icon="TrashIcon" />
        </b-button>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col md="3"> </b-col>
      <b-col md="6">
        <span><b>TOTAL</b> </span>
      </b-col>
      <b-col md="2" class="d-flex justify-content-center align-items-center">
        <b v-if="equipo != null">{{ equipo.bonificacion }}</b>
      </b-col>
    </b-row>

    <template #modal-footer>
      <div class="w-100">
        <template v-if="!showLoading">
          <b-button
            v-if="
              USER().rol === ROLES.SUPER ||
                USER().rol === ROLES.ADMIN ||
                USER().rol === ROLES.SANCIONES ||
                USER().rol === ROLES.TECNICA
            "
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="float-right"
            @click="insertBonificiacion"
          >
            Guardar
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            class="float-right mr-1"
            @click="onlyClose"
          >
            Cancelar
          </b-button>
        </template>
        <div v-if="showLoading" class="text-center mt-1">
          <b-spinner variant="primary" label="Text Centered" />
        </div>
        <b-alert
          :show="dismissCountDown"
          v-height-fade.appear
          :variant="variante"
          style="position:absolute; bottom:55px;  width:92%; margin-left:-4px"
          @dismiss-count-down="countDownChanged"
        >
          <div
            :class="{
              'alert-body danger': variante == 'danger',
              'alert-body success': variante == 'success',
            }"
          >
            {{ messageError }}
          </div>
        </b-alert>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormInput,
  BButton,
  BAlert,
  BSpinner,
  BFormTextarea,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import store from '@/store'
import { heightFade } from '@core/directives/animations'
import Ripple from 'vue-ripple-directive'
import apiCall from '../../utils/apiCall'
import {
  URL,
  // TARJETAS,
  USER,
  ROLES,
  // UBICACIONES,
  // xxxx,
  // xxxx,
} from '../../utils/variables'

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BFormTextarea,
    BButton,
    BAlert,
    BSpinner,
  },
  directives: {
    // 'b-tooltip': VBTooltip,
    Ripple,
    heightFade,
  },
  props: {
    // listEquiposElegidos: Array,
    equipo: Object,
    listBonificaciones: Array,
    // categoriaSeleccionada: Object,
    // accion: String,
  },
  setup(props, { emit }) {
    const bonificacion = ref(null)
    const motivo = ref(null)
    const showLoading = ref(false)
    const dismissCountDown = ref(0)
    const dismissSecs = ref(3)
    const messageError = ref('')
    // const dictamen = ref('')
    const variante = ref('danger')
    const { postApi } = apiCall()

    function initVariables() {
      showLoading.value = false
      motivo.value = null
      bonificacion.value = null
    }
    function resetModal(bvModalEvt) {
      bvModalEvt.preventDefault()
      initVariables()
    }
    function countDownChanged(dismissCountDownAux) {
      dismissCountDown.value = dismissCountDownAux
    }
    function showMessageAlert(type, mensaje) {
      variante.value = type
      messageError.value = mensaje
      dismissCountDown.value = dismissSecs.value
    }

    function validar() {
      let error = false
      if (bonificacion.value === null || bonificacion.value === 0) {
        error = true
        showMessageAlert('danger', 'Bonificación debe ser diferente de cero')
      } else if (motivo.value === null) {
        error = true
        showMessageAlert('danger', 'Motivo no debe ser vacio')
      }
      return error
    }

    async function deleteSancionEquipo(item) {
      showLoading.value = true
      const path = 'ApiFixture/deleteSancionEquipo'
      const data = {
        id_equipo: props.equipo.id_equipo,
        id_sancion_equipo: item.id_sancion_equipo,
        puntos: item.puntos,
        bonificacion_anterior: props.equipo.bonificacion,
        etapa: props.equipo.etapa,
        grupo: props.equipo.grupo,
        id_campeonato: props.equipo.id_campeonato,
        idTorneo:
          store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
      }
      // console.log(data)
      const response = await postApi(URL, path, data)
      if (response.flag === 'si') {
        // console.log('si')
        showMessageAlert('success', 'Eliminado exitosamente')
        emit('updateTabla')
        props.equipo.bonificacion = response.boniFinal
      } else {
        showMessageAlert('danger', response.mensaje)
      }
      showLoading.value = false
    }

    async function insertBonificiacion() {
      // const accion = defineAccion()
      // console.log(equipoSeleccionado.value)
      const hasError = validar()
      if (!hasError) {
        showLoading.value = true
        const path = 'ApiFixture/insertSancionEquipo'
        const data = {
          id_equipo: props.equipo.id_equipo,
          puntos: bonificacion.value,
          motivo: motivo.value,
          bonificacion_anterior: props.equipo.bonificacion,
          etapa: props.equipo.etapa,
          grupo: props.equipo.grupo,
          id_campeonato: props.equipo.id_campeonato,
          idTorneo:
            store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
        }
        // console.log(data)
        const response = await postApi(URL, path, data)
        if (response.flag === 'si') {
          // console.log('si')
          showMessageAlert('success', 'Agregado exitosamente')
          emit('updateTabla')
          initVariables()
          props.equipo.bonificacion = response.boniFinal
        } else {
          showMessageAlert('danger', response.mensaje)
        }
        showLoading.value = false
      }
    }

    function onlyClose() {
      store.commit('someVariables/UPDATE_SHOW_TARJETA_DICTAMEN', false)
    }
    return {
      showLoading,
      dismissCountDown,
      dismissSecs,
      messageError,
      variante,
      countDownChanged,
      showMessageAlert,
      onlyClose,
      resetModal,
      insertBonificiacion,
      ROLES,
      USER,
      motivo,
      bonificacion,
      deleteSancionEquipo,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
